import { Alert, Col, Form, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetInviteFilter } from "../ClientSideStates";
import { MazakaSelect } from "apps/Common/MazakaSelect";
import { FC } from "react";

const TopFilters: FC<{ isMobile: boolean }> = ({ isMobile }) => {
  const { filter } = useSelector((state: RootState) => state.invite);
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const handleInviteStatus = (value: any) => {
    const currentFilter = { ...filter };
    if (value||value===0) {
      currentFilter["InvitationStatus"] = value;
    } else  {
      delete currentFilter["InvitationStatus"];
    }
    dispatch(handleSetInviteFilter({ filter: currentFilter }));
  };
  const statusOptions = [
    { label: "Onay Bekleyenler", value: 0 },
    { label: "Kabul Edilenler", value: 1 },
    { label: "Reddedilenler", value: 2 },
  ];

  return (
    <Form form={form}>
      <Row gutter={[20, 0]}>
        {isMobile && (
          <Col xs={24}>
            <Alert
              message="Filtreler seçim yapıldığında otomatik uygulanır"
              className="!text-xs sm:!text-sm"
              type="info"
            />
          </Col>
        )}
        <MazakaSelect
          label={isMobile ? "Durum" : ""}
          xs={24}
          md={12}
          lg={6}
          allowClear
          placeholder="Durum"
          name={"InvitationStatus"}
          size="large"
          options={statusOptions}
          onChange={handleInviteStatus}
        />
      </Row>
    </Form>
  );
};

export default TopFilters;
